import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

/**
 * Material Design Icons
 * @ref https://materialdesignicons.com/
 */
import "@mdi/font/css/materialdesignicons.css";

/**
 * Roboto Font
 */
import "typeface-roboto/index.css";

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: "mdi"
    },
    theme: {
        dark: false,
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: colors.red.base,
                secondary: colors.yellow.darken1,
                accent: colors.grey.darken3
            },
            dark: {
                primary: colors.red.base,
                secondary: colors.yellow.darken1,
                accent: colors.grey.darken3
            }
        }
    }
});
